import React, { Component } from 'react';
import {
  PieChart,
  Pie,
  Sector,
  Cell,
} from 'recharts';
import { prepareData } from '../../utils/chart';

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    </g>
  );
};

export default class CustomPieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
    this.onPieEnter = this.onPieEnter.bind(this);
    this.getColors = this.getColors.bind(this);
    this.getData = this.getData.bind(this);
  }

  onPieEnter(data, index) {
    this.setState({
      activeIndex: index,
    });
  }

  getColors() {
    if (this.props.data && this.props.data.length > 0) {
      const newData = [];
      for (let i = 0; i < this.props.data.length; i++) {
        newData.push(this.props.data[i].highlight);
      }
      return newData;
    } else {
      return [
        '#0088FE',
        '#00C49F',
        '#FFBB28',
        '#FF8042'
      ];
    }
  }

  getData() {
    if (this.props.data && this.props.data.length > 0) {
      const newData = [];
      for (let i = 0; i < this.props.data.length; i++) {
        newData.push({
          name: this.props.data[i].label,
          value: this.props.data[i].value
        });
      }
      return newData;
    } else {
      return [];
    }
  }

  render() {
    const data = this.getData();
    const colors = this.getColors();

    if (data.length === 0) {
      return (
        <div>
          <h3 style={{ textAlign: 'center', paddingTop: '20%' }}>
            <i className="fa fa-pie-chart"></i>
            <span style={{ paddingLeft: '5px' }}>No data for chart</span>
          </h3>
        </div>
      );
    }

    return (
      <div>
        <PieChart width={800} height={400}>
          <Pie
            activeIndex={this.state.activeIndex}
            activeShape={renderActiveShape}
            data={data}
            cx={300}
            cy={200}
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            onMouseEnter={this.onPieEnter}
          >
            {data.map((entry, index) => <Cell fill={colors[index % colors.length]}/>)}
          </Pie>
        </PieChart>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/CustomPieChart/index.js